(function () {
  function initResultsRoutine(root) {
    if (!root || root.dataset.alRrReady === 'true') return;
    root.dataset.alRrReady = 'true';

    var tabButtons = root.querySelectorAll('[data-al-rr-tab]');
    var panels = root.querySelectorAll('[data-al-rr-panel]');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-al-rr-tab');

        tabButtons.forEach(function (tab) {
          var isActive = tab === button;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-al-rr-panel') === target;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', 'hidden');
          }
        });
      });
    });

  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.al-rr').forEach(initResultsRoutine);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
